import { Defaults } from 'es-decorators'
import { BodyView } from 'es6/views/body-view'
import { RemoteItemsPopupView } from 'es6/views/popups/remote-items-popup-view'
import { getCookie } from 'helpers/cookie-helper'
import Backbone, { getGlobalEventBus } from 'init/backbone'
import delay from 'lodash/delay'
import { ExpandableBlockView } from './expandable-block-view'
import $ from 'init/jquery'
import { MobileSmartBannerView } from './mobile-smart-banner-view'
import { jsonFeatures } from 'init/json-features'
import { toggleViewLock } from 'helpers/scroll-lock-helper'
import isNumber from 'lodash/isNumber'
import { getTemplate } from 'helpers/template-helper'
import { CQC_COMMAND_TYPES, CQC_COMMAND_EVENT } from 'es6/constants'
import { UserCurrent } from 'es6/models/user-current'

@Defaults({
  el: 'body',
  events: {
    'click .mature': 'setMature',
    'click .to-authorisation': 'toAuthorisationForm',
    'click .to-registry': 'toRegistry',
    'click .top-error-chponck .js-popup-close': 'closeGlobalError',
    'click .dropdown-new-menu-heading': 'toggleDropMenuList',
  },
  globalErrorTemplate: '#top-error-chponk-template',
  additionalOptions: ['router', 'autoRewritePageLinks'],
  savedScrollPosition: 0,
})

export class MobileBodyView extends BodyView {
  /**
   * @inheritDoc
   */
  run () {
    this.setChoiceCityForms()

    this.$('.js-close-top-chponck').on('click', event => {
      this.closeTopBanner(event)
    })
    if (!getCookie('isRemotePopupShown')
      && jsonFeatures.is_remote_items_popup_enabled) {
      this.childViews.remoteitemsPopupView = new RemoteItemsPopupView({
        cart: this.cart,
      })
    }
    this.childViews.footerBlock = new ExpandableBlockView({
      el: '.footer-menu',
    })

    this.childViews.mobileSmartBanner = new MobileSmartBannerView()
    this.listenTo(this.router, 'change-get-params', this.rewritePageLinks)
    if (this.settlement) {
      this.toggleBodyClassRemoteDisable()
    }
    this.listenTo(this.settlement, 'change', this.toggleBodyClassRemoteDisable)
    delay(this.rewritePageLinks.bind(this), 1, { catalog: 'main' })
    this.listenTo(Backbone, 'rewrite-mobile-links', this.rewritePageLinks)
    this.listenTo(Backbone, 'global-error', this.showGlobalError)
    this.listenTo(Backbone, 'block-screen', this.toggleScrollLock)
    this.listenTo(Backbone, 'toggle-layout-view', this.toggleLayoutView)
    this.listenTo(getGlobalEventBus(), 'block-screen', this.toggleScrollLock)
    this.listenTo(getGlobalEventBus(), 'toggle-layout-view', this.toggleLayoutView)
    this.listenTo(Backbone, 'toggle-body-lock', this.toggleBodyLock)
    const phoneNumbers = $('.js-need-format-phone')
    if (phoneNumbers.length) {
      this.formatPhoneNumbers(phoneNumbers)
    }
    this.userCurrent = new UserCurrent()
  }

  /**
   * Устанавливает параметр совершеннолетия пользователя.
   */
  setMature () {
    if (!this.user.get('is_mature')) {
      const isAdultForEveryone = jsonFeatures.is_adult_for_everyone_enabled;
      if (isAdultForEveryone) {
        this.userCurrent.set({is_mature: 1})
        this.userCurrent.sync('update', this.userCurrent, {is_mature: 1})
        $('.one-new-description').removeClass('with-blur')
      } else {
        this.user.set({is_mature: 1, scenario: 'api-confirmation'})
        this.user.save()
      }
      this.$('.item-protected-blank').addClass('not_display')
      $('body').removeClass('not-mature')
    }
  }

  /**
   * Открывает окно авторизации.
   */
  toAuthorisationForm () {
    Backbone.trigger(CQC_COMMAND_EVENT, { type: CQC_COMMAND_TYPES.showAuthForm })
  }

  /**
   * Открывает окно регистрации.
   */
  toRegistry () {
    Backbone.trigger(CQC_COMMAND_EVENT, { type: CQC_COMMAND_TYPES.showRegistrationForm })
  }

  /**
   * Показывает попап глобальной ошибки
   * @param {Object} data Данные ошибки
   */
  showGlobalError (data) {
    if (!this.$('.top-error-chponck').length) {
      this.globalErrorTemplate = getTemplate(this.globalErrorTemplate)
      this.$('div[data-jsview]').before(this.globalErrorTemplate())
    }
    if (this.$('.top-error-chponck').length) {
      if (data && data.error) {
        this.$('.top-error-chponck .global-errors').html(data.error).removeClass('not_display')
        if (this.$('.top-error-chponck').outerHeight() === 0) {
          $('html, body').animate({ scrollTop: 0 }, 500, () => {
            this.$('.top-error-chponck').animate({ height: this.$('.top-error-message').outerHeight() + 'px' }, 350, () => {
              $(this).css({ height: 'auto' })
            })
          })
        }
      }
    }
  }

  /**
   * Скрывает попап глобальной ошибки
   */
  closeGlobalError () {
    if (this.$('.top-error-chponck').outerHeight() > 0) {
      this.$('.top-error-chponck').animate({ height: '0px' }, 350, () => {
        this.$('.top-error-chponck .global-errors').html('').addClass('not_display')
      })
    }
  }

  /**
   * Открытие и закрытие выпадающих списков
   * @param {Event} event
   */
  toggleDropMenuList (event) {
    $(event.target).closest('.dropdown-new-menu-heading').toggleClass('active')
  }

  /**
   * Показ блоков
   * @param {Event} event
   */
  toggleBlock (event) {
    this.$(event.currentTarget).toggleClass('active')
    if ($(event.currentTarget).data('tab') === 'search') {
      this.$('.search-block').addClass('active')
      Backbone.trigger('show-search-history')
    } else {
      this.$('.search-block').removeClass('active')
    }
  }

  /**
   * Переключает видимость контента и подвала страницы.
   * @param {boolean} [isDisplay] Признак показа блока.
   */
  toggleLayoutView (isDisplay) {
    const $layout = this.$el.children('.wrapper')
    const $footer = this.$('#footer__root')
    const $smartAppBanner = this.$('.smart-app-banner')
    if (!arguments.length) {
      isDisplay = !$layout.hasClass('not_display')
    }
    $layout.toggleClass('not_display', !isDisplay)
    $footer.toggleClass('not_display', !isDisplay)
    if (!this.topChponckIsClosed) {
      this.topChponck.toggleClass('not_display', !isDisplay)
    }
    if (this.childViews.mobileSmartBanner && this.childViews.mobileSmartBanner.isCookeiActive()) {
      $smartAppBanner.toggleClass('not_display', !isDisplay)
    }
  }

  /**
   * Блокирует/разблокирует скролл.
   * @param {boolean} [isLock] Признак блокировки скролла.
   */
  toggleBodyLock (isLock) {
    const valueScrollPosition = this.savedScrollPosition
    const scrollPosition = toggleViewLock(this.$el, isLock, true, valueScrollPosition)
    if (isNumber(scrollPosition)) {
      this.savedScrollPosition = scrollPosition
    }
  }
}
